import { Injectable } from '@angular/core';
import { Action } from '@ngrx/store';
import { NavigationService } from 'src/app/core/services/navigation/navigation.service'
import { Actions, Effect, ofType } from '@ngrx/effects';
import { AuthActionTypes, Register, RegSuccess, RegFailure, LoginFailure, LoginSuccess, Login, Logout ,Tupas,TupasFailure,TupasSuccess, LogoutSuccess, LogoutFailure} from '../actions/authenticationActions';

import { Observable } from 'rxjs';
import 'rxjs/add/observable/of';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/switchMap';
import 'rxjs/add/operator/mergeMap';
import 'rxjs/add/operator/catch';

import { tap } from 'rxjs/operators';

import { RegisterService } from '../../app/pages/register/register.service';
import { NextstepsService } from '../../app/pages/nextsteps/nextsteps.service';

import { LoginService } from '../../app/pages/login/login.service';



@Injectable()
export class AuthEffects {

  constructor(
    private actions: Actions,
    private registerService: RegisterService,
    private loginService: LoginService,
    private navigate: NavigationService,
    private nextStep: NextstepsService,
    

  ) { }

  // effects go here
  @Effect()
  Register: Observable<any> = this.actions
    .ofType(AuthActionTypes.REGISTER)
    .map((action: Register) => action.payload)
    .mergeMap(payload => {
      return this.registerService.signUp(payload)
        .map((data) => {

          if(!data.success)
          {
            return new RegFailure({ error: data});
          }
          return new RegSuccess({ 
            token: data.data.token.access_token, 
            email: data.data.email, 
            name: data.data.name,
            isAuthenticated: true,  
            success: data.success,
            successMessage: data.message });

        })
        .catch((error) => {
          //Common failure
          return Observable.of(new RegFailure({ error: error }));
        });
    });
  @Effect()
  Login: Observable<any> = this.actions
    .ofType(AuthActionTypes.LOGIN)
    .map((action: Login) => action.payload)
    .mergeMap(payload => {
      return this.loginService.login(payload)
        .map((user) => {
          if(!user.success)
          {
            return new LoginFailure({ error: user});
          }
          return new LoginSuccess(
            
            { 
            token: user.data.token.access_token, 
            email: user.data.email, 
            name: user.data.name,
            isAuthenticated: true, 
            success: user.success,
            successMessage: user.message
           });
          

        })
        .catch((error) => {
          return Observable.of(new LoginFailure({ error: error }));
        });
    });

  @Effect()
  Logout: Observable<any> = this.actions
    .ofType(AuthActionTypes.LOGOUT)
    .map((action: Logout) => action.payload)
    .mergeMap(payload => {
      return this.loginService.logout()
        .map((user) => {
          return new LogoutSuccess({ token: '', email: {}, isAuthenticated: false });
        })
        .catch((error) => {
          return Observable.of(new LogoutFailure({ error: error }));
        });
    });

  // @Effect({ dispatch: false })
  // Success: Observable<any> = this.actions.pipe(
  //   ofType(AuthActionTypes.SUCCESS),
  //   tap((user) => {
  //     if (user.payload.token) {
  //       localStorage.setItem('token', user.payload.token);
  //       this.navigate.navigateTo('nextstep');
  //     }
  //     else {
  //       localStorage.setItem('token', '');
  //       this.navigate.navigateTo('');
  //     }

  //   })
  // );

  // @Effect({ dispatch: false })
  // Failure: Observable<any> = this.actions.pipe(
  //   ofType(AuthActionTypes.FAILURE)
  // );

  @Effect()
  Tupas: Observable<any> = this.actions
    .ofType(AuthActionTypes.TUPAS)
    .map((action: Tupas) => action.payload)
    .mergeMap(payload => {
      return this.nextStep.tupas(payload)
        .map((tupas) => {
          if(!tupas.success)
          {
            return new TupasFailure({ error: tupas});
          }
          return new TupasSuccess(
            { 
            success: tupas.success,
            successMessage: tupas.message,
            url:tupas.data.url
           });

        })
        .catch((error) => {
          return Observable.of(new TupasFailure({ tupasVerified: false }));
        });
    });
   /*  @Effect({ dispatch: false })
    TupasSuccess: Observable<any> = this.actions.pipe(
      ofType(AuthActionTypes.TUPAS_SUCCESS),
      tap((tupas) => {
             window.location.href = tupas.payload.url
  
      })
    );
  
    @Effect({ dispatch: false })
    TupasFailure: Observable<any> = this.actions.pipe(
      ofType(AuthActionTypes.TUPAS_FAILURE)
    ); */
}
